module.exports = __webpack_public_path__ + "img/truck1.77a2d201.png";